import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

const parseCsv = (value: string | null): string[] => {
	if (!value) return []
	return value.split(',').map((id) => id.trim()).filter(Boolean)
}

export interface BreadcrumbSelection {
	adPlatforms: string[]
	adAccountIds: string[]
	campaignIds: string[]
	adPlatformsCsv: string
	adAccountIdsCsv: string
	campaignIdsCsv: string
	firstAdAccountId: string | null
	firstCampaignId: string | null
}

export const useBreadcrumbSelection = (): BreadcrumbSelection => {
	const [searchParams] = useSearchParams()

	return useMemo(() => {
		const adPlatforms = parseCsv(
			searchParams.get('platforms') || searchParams.get('platform')
		)
		const adAccountIds = parseCsv(
			searchParams.get('adAccounts') || searchParams.get('adAccount')
		)
		// No campaign parameter means All campaigns. Leave the filter empty so
		// the backend includes all campaigns within the selected account scope.
		const campaignIds = parseCsv(
			searchParams.get('campaigns') ||
				searchParams.get('breadCampaigns') ||
				searchParams.get('breadCampaign') ||
				searchParams.get('campaign')
		)

		return {
			adPlatforms,
			adAccountIds,
			campaignIds,
			adPlatformsCsv: adPlatforms.join(','),
			adAccountIdsCsv: adAccountIds.join(','),
			campaignIdsCsv: campaignIds.join(','),
			firstAdAccountId: adAccountIds[0] ?? null,
			firstCampaignId: campaignIds[0] ?? null
		}
	}, [searchParams])
}
